import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { getPwaInstallText } from '../constants/pwaInstallText';
import {
  getPwaInstallRuntimeState,
  markPwaInstallPromotionComplete,
  promptPwaInstall,
  subscribePwaInstallState
} from '../services/pwaInstallService';
import styles from './PwaInstallGuidePage.module.css';

function InstructionCard({ title, steps, notice }) {
  return (
    <section className={styles.card}>
      <h2 className={styles.cardTitle}>{title}</h2>
      {notice && <p className={styles.notice}>{notice}</p>}
      <ol className={styles.steps}>
        {steps.map((step) => <li key={step}>{step}</li>)}
      </ol>
    </section>
  );
}

export default function PwaInstallGuidePage() {
  const { userInfo } = useContext(UserContext);
  const navigate = useNavigate();
  const [runtime, setRuntime] = useState(getPwaInstallRuntimeState);
  const [isInstalling, setIsInstalling] = useState(false);
  const text = getPwaInstallText(userInfo?.preferred_language);
  const homeRoute = userInfo?.level === 'guest_artist' ? '/guest' : '/client';

  useEffect(() => subscribePwaInstallState(setRuntime), []);

  const handleInstall = async () => {
    setIsInstalling(true);
    const result = await promptPwaInstall();
    setIsInstalling(false);

    if (result.outcome === 'accepted') {
      markPwaInstallPromotionComplete(userInfo?.user_id);
      navigate(homeRoute);
    }
  };

  const handleAlreadyInstalled = () => {
    markPwaInstallPromotionComplete(userInfo?.user_id);
    navigate(homeRoute);
  };

  const instruction = runtime.isIos
    ? {
      title: text.iosSafariTitle,
      steps: text.iosSafariSteps,
      notice: runtime.isSafari ? null : text.iosOtherNotice
    }
    : runtime.isAndroid
      ? { title: text.androidTitle, steps: text.androidSteps, notice: null }
      : { title: text.desktopTitle, steps: text.desktopSteps, notice: null };

  return (
    <main className={styles.page}>
      <div className={styles.content}>
        <img className={styles.appIcon} src="/app-icon.png" alt="" />
        <h1 className={styles.title}>{text.guideTitle}</h1>
        <p className={styles.intro}>{text.guideIntro}</p>

        {runtime.canPrompt && (
          <button
            type="button"
            className={styles.installButton}
            onClick={handleInstall}
            disabled={isInstalling}
          >
            {isInstalling ? text.installing : text.installNow}
          </button>
        )}

        <InstructionCard {...instruction} />

        <div className={styles.footerActions}>
          <button type="button" className={styles.backButton} onClick={() => navigate(homeRoute)}>
            {text.back}
          </button>
          <button type="button" className={styles.installedButton} onClick={handleAlreadyInstalled}>
            {text.alreadyInstalled}
          </button>
        </div>
      </div>
    </main>
  );
}
